import { render, staticRenderFns } from "./orgitemviewApp.vue?vue&type=template&id=138084c4"
import script from "./orgitemviewApp.vue?vue&type=script&lang=js"
export * from "./orgitemviewApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports